import { Search, Menu, User } from "lucide-react";
import { NavLink, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import logo from "@/assets/brim-mob-header-logo.png";
import { CartDrawer } from "@/components/CartDrawer";
import { CurrencySwitcher } from "@/components/CurrencySwitcher";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { SearchDialog } from "@/components/SearchDialog";

const navItems = [
  { to: "/drops", label: "DROPS" },
  { to: "/hats", label: "HATS" },
  { to: "/league", label: "LEAGUE" },
  { to: "/exclusives", label: "EXCLUSIVES" },
  { to: "/accessories", label: "ACCESSORIES" },
];

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSignedIn(!!data.session));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, session) => setSignedIn(!!session));
    return () => sub.subscription.unsubscribe();
  }, []);
  return (
  <header className="sticky top-0 z-50 bg-background/90 backdrop-blur-md border-b border-border animate-[page-fade_0.9s_cubic-bezier(0.22,1,0.36,1)_both]">
    <div className="container flex items-center justify-between h-16 sm:h-20 gap-2">
      <nav className="hidden lg:flex items-center gap-6 lg:gap-8 font-display flex-1 pr-0 min-w-0">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            style={{ fontSize: "16.5px" }}
            className={({ isActive }) =>
              `link-underline leading-none transition-colors duration-300 hover:text-accent ${isActive ? "text-accent" : ""}`
            }
          >
            {item.label}
          </NavLink>
        ))}
        <NavLink
          to="/sale"
          style={{ fontSize: "16.5px" }}
          className="link-underline leading-none text-red-600 transition-colors duration-300 hover:text-red-700"
        >
          SALE
        </NavLink>
      </nav>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <button className="lg:hidden" aria-label="Open menu"><Menu className="w-6 h-6" /></button>
        </SheetTrigger>
        <SheetContent side="left" className="w-72">
          <nav className="flex flex-col gap-6 mt-10 font-display text-lg">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `transition-colors duration-300 hover:text-accent ${isActive ? "text-accent" : ""}`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink to="/sale" onClick={() => setOpen(false)} className="text-red-600 hover:text-red-700">
              SALE
            </NavLink>
            <Link to={signedIn ? "/account/profile" : "/account/sign-in"} onClick={() => setOpen(false)} className="hover:text-accent">
              ACCOUNT
            </Link>
          </nav>
        </SheetContent>
      </Sheet>
      <Link to="/" className="absolute left-1/2 -translate-x-1/2 pointer-events-auto">
        <img
          src={logo}
          alt="Brim Mob"
          width={256}
          height={128}
          fetchPriority="high"
          decoding="async"
          className="h-9 sm:h-12 lg:h-16 w-auto max-w-[40vw] object-contain"
        />
      </Link>
      <div className="flex items-center gap-2 sm:gap-3 lg:gap-5 flex-1 justify-end min-w-0">
        <Link
          to={signedIn ? "/account/profile" : "/account/sign-in"}
          aria-label="Account"
          className="hidden lg:inline-flex items-center justify-center transition-colors duration-300 hover:text-accent"
        >
          <User className="w-5 h-5" />
        </Link>
        <CurrencySwitcher />
        <SearchDialog>
          <button
            type="button"
            aria-label="Search"
            className="hidden lg:inline-flex items-center justify-center transition-colors duration-300 hover:text-accent"
          >
            <Search className="w-5 h-5" />
          </button>
        </SearchDialog>
        <CartDrawer />
      </div>
    </div>
  </header>
  );
};